import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import ListViewProps from './ListViewProps'


export default {
    props: ListViewProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoListView(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoListView()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-listview-vue-wrapper/src/KendoListView/KendoListViewMixin.js